<template>
  <div class="row">
    <div class="col-2"></div>
    <div class="col">
      <form v-if="fields.length > 0">
        <h3 style="text-align: center">Resposta do Formulário</h3>
        <div class="question-form">
          <h5 class="label-form" style="text-align: center">{{ formBuilder.nomeForm }}</h5>
        </div>

        <div class="question-form" v-for="(field, index) in fields" :key="index">
          <label :for="field.id" class="label-form">{{ index + 1 }}. {{ field.label }}<b style="color: red; font-size: 15px; margin-left: 5px" v-if="field.required">*</b></label>

          <input class="form-control form-input-component" v-if="field.type === 'text'" :id="'questao' + field.id" :name="field.id" v-model="field.respostaText" v-bind:class="{ 'is-invalid': submitted && !this.formCreated['questao' + field.id] && field.required }" type="text" :disabled="desabilitar" />

          <textarea class="form-control form-input-component" v-if="field.type === 'textarea'" :id="'questao' + field.id" v-model="field.respostaText" v-bind:class="{ 'is-invalid': submitted && !this.formCreated['questao' + field.id] && field.required }" :name="field.id" :disabled="desabilitar"></textarea>

          <select class="form-control form-input-component" v-if="field.type === 'select'" :id="'questao' + field.id" :disabled="desabilitar" v-model="field.respostaObjeto" v-bind:class="{ 'is-invalid': submitted && !this.formCreated['questao' + field.id] && field.required }">
            <option v-for="(option, optionIndex) in field.options" :key="optionIndex" :value="option">
              {{ option.label }}
            </option>
          </select>

          <div v-if="field.type === 'radio'">
            <div class="form-check" v-for="(option, optionIndex) in field.options" :key="optionIndex">
              <input class="form-check-input" type="radio" name="flexRadioDefault" v-model="option.selected" :disabled="desabilitar" v-bind:class="{ 'is-invalid': submitted && !this.formCreated['questao' + field.id] && field.required }" :id="'questao' + field.id" @click="setRadioValue(option, field)" />
              <label class="form-check-label">
                {{ option.label }}
              </label>
            </div>
          </div>

          <div v-if="field.type === 'checkbox'">
            <div class="form-check" v-for="(option, optionIndex) in field.options" :key="optionIndex">
              <input class="form-check-input" type="checkbox" value="{{option}}" :disabled="desabilitar" v-model="option.selected" v-bind:class="{ 'is-invalid': submitted && !this.formCreated['questao' + field.id] && field.required }" @click="setCheckValue(option, field)" id="flexCheckDefault" />
              <label class="form-check-label" for="flexCheckDefault">
                {{ option.label }}
              </label>
            </div>
          </div>
        </div>
        <div class="container row">
          <div class="col justify-content-end" style="margin-top: 5px">
            <div class="float-end">
              <button type="button" class="btn btn-primary" @click="salvarRespostas">Responder Formulário</button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-3"></div>
  </div>
</template>

<script>
import { createRespostas, getFormRespostasById } from '@/components/service/formBuilderRespostasService';
import { openNotification, typesNotification } from '@/utils/notifications';

export default {
  name: 'FormBuilderQuestionsView',
  props: {
    idFormResp: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      fields: [],
      idForm: null,
      nomeForm: null,
      formCreated: {},
      submitted: false,
      desabilitar: true,
    };
  },
  async created() {
    if (this.idFormResp) {
      this.$route.query.id = this.idFormResp;
      this.desabilitar = false;
    }
    if (this.$route.query.id) {
      this.idForm = this.$route.query.id;
      await this.recuperarForm();
    }
  },
  methods: {
    async recuperarForm() {
      await getFormRespostasById(this.idForm).then(async (form) => {
        this.formBuilder = form.data;
        this.fields = this.formBuilder.respostas;
        for (let field of this.fields) {
          if (field.options) {
            for (let option of field.options) {
              if (field.type === 'checkbox') {
                if (field.respostaOptions) {
                  if (field.respostaOptions.find((opr) => opr.label === option.label)) {
                    option['selected'] = true;
                  }
                }
              } else if (field.type === 'radio') {
                if (field.respostaObjeto) {
                  if (field.respostaObjeto.label === option.label) {
                    option['selected'] = true;
                  }
                }
              }
            }
          }
        }
      });
    },
    setRadioValue(option, field) {
      for (let resp of this.formBuilder.respostas) {
        if (resp.id === field.id) {
          for (let opts of resp.options) {
            opts.selected = false;
          }
          let opt = resp.options.find((op) => op.label === option.label);
          resp.respostaObjeto.label = option.label;
          opt.selected = true;
        }
      }
      return true;
    },
    setCheckValue(option, field) {
      for (let resp of this.formBuilder.respostas) {
        if (resp.id === field.id) {
          // let checkValue = {};
          let op = resp.respostaOptions.find((opts) => opts.label === option.label);
          if (op) {
            resp.respostaOptions.splice(resp.respostaOptions.indexOf(op), 1);
          } else {
            resp.respostaOptions.push(option);
          }
        }
      }
    },

    async salvarRespostas() {
      this.submitted = false;
      for (let ques of this.formBuilder.respostas) {
        if (ques.type === 'radio' && !ques.respostaObjeto) {
          if (ques.required) {
            this.submitted = true;
            openNotification(typesNotification.warning, 'Preencher campos obrigatórios');
            break;
          }
        } else if (ques.type === 'checkbox' && ques.respostaOptions.length === 0) {
          if (ques.required) {
            this.submitted = true;
            openNotification(typesNotification.warning, 'Preencher campos obrigatórios');
            break;
          }
        } else {
          let resposta = document.getElementById('questao' + ques.id);
          if (!resposta && ques.required) {
            this.submitted = true;
            openNotification(typesNotification.warning, 'Preencher campos obrigatórios');
            break;
          }
          if (ques.type === 'select') {
            ques.respostaObjeto = { label: resposta.options[resposta.selectedIndex].text };
          } else if (ques.type === 'text' || ques.type === 'textarea') {
            ques.respostaText = resposta.value;
          }
        }
      }

      if (!this.submitted) {
        await createRespostas(this.formBuilder).then(() => {
          openNotification(typesNotification.success, 'Formulário respondido com sucesso.');
          this.$emit('reload-table', { reload: true });
        });
      }
    },
  },
};
</script>

<style scoped>
#uploadImg {
  display: none;
}

.question-form {
  background: white;
  padding: 26px;
  border-radius: 10px 10px;
  margin-bottom: 10px;
}

.label-form {
  margin-bottom: 25px;
  font-family: ROBOTO, serif;
  font-size: 23px;
}

.form-check {
  font-size: 18px;
}
</style>
